"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var frame_1 = require("../../frame");
var stompProtocolV1_1_1 = require("./stompProtocolV1_1");
// STOMP protocol with the version V1_2
var stompProtocolV1_2 = function () {
    var currentProtocol = stompProtocolV1_1_1.default();
    var getMessageId = function (frame) {
        return frame.headers.ack || currentProtocol.getMessageId(frame);
    };
    var ack = function (messageID, subscription, headers) {
        return frame_1.default.marshall('ACK', __assign({}, headers, { 'id': messageID, subscription: subscription }));
    };
    var nack = function (messageID, subscription, headers) {
        return frame_1.default.marshall('NACK', __assign({}, headers, { 'id': messageID, subscription: subscription }));
    };
    return __assign({}, currentProtocol, { ack: ack, nack: nack, getMessageId: getMessageId });
};
exports.default = stompProtocolV1_2;
